// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EALJ2","tableContainer":"styles_tableContainer__QG6vA","prizes":"styles_prizes__xsgxA","highlightRow":"styles_highlightRow__j95O_"};